export const environment = {
  serverUrl: 'https://test-api.southasiandigest.com/v1/',
    // serverUrl: 'https://api.southasiandigest.in/v1/',
}
